export default __webpack_public_path__ + "static/SRUS LF235 - Product Specifications & Technical Data-01e7e5ae6aef2c77854efb4c771ad098.pdf";